import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { useResponsive } from 'src/hooks/use-responsive';

import { NAV, HEADER } from './config-layout';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, navWidth = NAV.WIDTH, ...other }) {
  const lgUp = useResponsive('up', 'lg');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        py: `${HEADER.H_MOBILE + SPACING}px`,
        px: { xs: 1.5, sm: 2 },
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        overflowX: 'hidden',
        boxSizing: 'border-box',
        '& > *': { minWidth: 0, maxWidth: '100%' },
        transition: (theme) =>
          theme.transitions.create('width', { duration: theme.transitions.duration.shorter }),
        ...(lgUp && {
          px: 2.5,
          py: `${HEADER.H_DESKTOP + SPACING}px`,
          width: `calc(100% - ${navWidth}px)`,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  navWidth: PropTypes.number,
};
